import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';

/**
 * RxJSのサブスクリプションを管理し、メモリリークを防ぐサービス
 */
@Injectable()
export class SubscriptionManagerService implements OnDestroy {
  private destroy$ = new Subject<void>();
  private subscriptions = new Set<Subscription>();

  /**
   * ObservableにtakeUntilを適用して自動的にunsubscribeされるようにする
   */
  manage<T>(observable: Observable<T>): Observable<T> {
    return observable.pipe(takeUntil(this.destroy$));
  }

  /**
   * サブスクリプションを追加して管理
   */
  add(subscription: Subscription): void {
    this.subscriptions.add(subscription);
    
    // サブスクリプションが完了したら自動的にSetから削除
    subscription.add(() => {
      this.subscriptions.delete(subscription);
    });
  }

  /**
   * 特定のサブスクリプションを手動でunsubscribe
   */
  unsubscribe(subscription: Subscription): void {
    if (this.subscriptions.has(subscription)) {
      subscription.unsubscribe();
      this.subscriptions.delete(subscription);
    }
  }

  /**
   * すべてのサブスクリプションをクリーンアップ
   */
  cleanup(): void {
    // すべてのサブスクリプションをunsubscribe
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions.clear();
    
    // destroy$を発火してtakeUntilを使用しているObservableを完了
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

}